import { useState } from 'react';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What does MW mean and why do you price by MW?',
      answer: 'MW stands for megawatt, a measure of system capacity. Solar farms are typically sized and sold by MW, so pricing by MW creates a consistent benchmark across sites. It accounts for the actual scale of the system rather than just land area, which can vary based on panel density and layout.',
    },
    {
      question: 'How many acres is 1 MW?',
      answer: 'A typical rule of thumb is 1 MW equals about 4 to 6 acres, depending on panel density, spacing, and site layout. We use 5 acres per MW as a common estimate. Dense installations may be closer to 4 acres per MW, while more conservative layouts may be 6 acres per MW.',
    },
    {
      question: 'Why do small sites cost more per MW?',
      answer: 'Smaller sites require the same mobilization, setup, and reporting effort as larger sites, but spread across fewer MW. Our pricing scales fairly: small sites pay a premium per MW, while utility-scale sites benefit from efficiency at scale. The calculator automatically adjusts the per-MW rate based on site size.',
    },
    {
      question: 'Do you need to shut the site down?',
      answer: 'No. Drone inspections are non-intrusive and do not require shutting down the site. We fly over active systems and capture thermal and visual data without interrupting power generation. This is one of the key advantages of drone inspections over traditional methods.',
    },
    {
      question: "What's the difference between thermal and visual?",
      answer: 'Visual (RGB) inspections capture high-resolution photos to identify physical damage, soiling, shading, and structural issues. Thermal (infrared) inspections detect hot spots, failed cells, and underperforming sections that are invisible to the naked eye. The Full Diagnostic Package combines both for comprehensive analysis.',
    },
    {
      question: 'What do you deliver?',
      answer: 'Deliverables depend on the service: Visual inspections include high-res photos, annotated findings, and issue summaries. Thermal inspections include thermal maps, hot-spot lists with location pins, and priority summaries. The Full Diagnostic Package includes both plus defect categorization, severity ranking, and an executive summary PDF with recommended next steps.',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-stone-900 mb-10 text-center">Frequently Asked Questions</h2>
        
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div key={index} className="border border-stone-200 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-stone-50 transition-colors"
              >
                <span className="font-semibold text-stone-900 pr-4">{faq.question}</span>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-xl text-stone-400 flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4 text-stone-600 leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
